/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import AnalytesRow from './AnalytesRow';

let AnalytesRows = ({
  children, router
}: any): React.Element => (
  TBody({
    children: children.map(analyte => (
      <AnalytesRow
        key={ analyte.id }
        router={ router }
      >
        { analyte }
      </AnalytesRow>
    ))
  })
);

export default AnalytesRows;
